export default "__VITE_ASSET__Cl15rx9L__"